import { useDataValue } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let transactions = useDataValue({
    context: 'transactions',
    viewPath: props.viewPath,
  })

  let allCount = transactions.length

  return <View {...props} allCount={allCount} />
}
